import { get } from 'helpers/api';
import snakecaseKeys from 'snakecase-keys';
import { snakeCase } from 'helpers/formatters/string_formats';

import debounceActionCreators from 'helpers/redux/debounce_action_creators';

const debouncedActionCreators = debounceActionCreators({ retrieveRecords }, 1000);

export const SET_RECORDS = 'SET_RECORDS';
function setRecords(records) {
  return { ...records, type: SET_RECORDS };
}

export const RETRIEVE_RECORDS_STARTED = 'RETRIEVE_RECORDS_STARTED';
function retrieveRecordsStarted(abortController) {
  return { abortController, type: RETRIEVE_RECORDS_STARTED };
}

export function retrieveRecords() {
  return (dispatch, getState) => {
    const { paths, query, search } = getState();

    if (search.abortController) search.abortController.abort();

    const abortController = new AbortController();
    dispatch(retrieveRecordsStarted(abortController));

    get(paths.leads, {
      signal: abortController.signal,
      params: {
        ...filterOptionsAsQueryParameter(query),
        page: query.page,
        sortColumn: snakeCase(query.sort.column),
        sortOrder: query.sort.order
      }
    }).then((records) => {
      dispatch(setRecords(records));
    });
  };
}

export function delayRetrieveRecords() {
  return (dispatch) => {
    dispatch(retrieveRecordsStarted());
    return debouncedActionCreators.retrieveRecords(dispatch);
  };
}

export function filterOptionsAsQueryParameter(query) {
  const params = {};

  if (query.searchText.length > 0) params.query = query.searchText;
  if (query.brokerFilter.length > 0) params.primaryBroker = query.brokerFilter;
  if (query.referralSourceFilter.length > 0) params.referralSource = query.referralSourceFilter;
  if (query.statusFilter.length > 0) params.status = query.statusFilter;
  if (query.waitlistFilter.length > 0) params.waitlistStatuses = query.waitlistFilter;
  if (query.profileUserTypeFilter.length > 0) params.profileUserType = query.profileUserTypeFilter;
  if (query.propertyFilter.length > 0) params.property = query.propertyFilter;
  if (query.caStatusFilter.length > 0) params.caStatus = query.caStatusFilter;
  if (query.companyFilter.length > 0) params.company = query.companyFilter;
  if (query.startDate) params.startDate = query.startDate;
  if (query.endDate) params.endDate = query.endDate;

  return snakecaseKeys(params);
}
